import { PageTemplateView } from "@loot-os/design-system/templates/shared/PageTemplateView";

import { useTenant } from "../lib/tenant.js";
import { useBattlesLobbyContent } from "../templates/pages/battles/lobby/useBattlesLobbyContent.js";
import { storefrontTemplateOf } from "../templates/registry.js";

/** GET /v1/battles, laid out by the storefront template this environment chose. */
export function BattlesPage() {
  const { config } = useTenant();
  return (
    <PageTemplateView
      template={storefrontTemplateOf(config).battles}
      content={useBattlesLobbyContent()}
    />
  );
}
